// Coordinate first creation across the extension's tabs and worker. Re-read
// the backend inside the lock; a cached empty overview is not authoritative.
const pending = new Map();

export function withDatastoreCreationLock(scope, task) {
  const key = `psono-datastore-create:${JSON.stringify(scope)}`;
  if (globalThis.navigator?.locks?.request) {
    return navigator.locks.request(key, { mode: "exclusive" }, task);
  }
  // Older environments retain one creation per realm, without claiming
  // coordination across processes where Web Locks are unavailable.
  if (pending.has(key)) return pending.get(key);
  const promise = Promise.resolve()
    .then(task)
    .finally(() => pending.delete(key));
  pending.set(key, promise);
  return promise;
}
